import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["onClick", "onClickLinkCallback", "isExternal", "path", "label", "children"];
import React from 'react';
import Button from './Button';
import LinkButton from './LinkButton';
import AnchorButton from './AnchorButton';

var RenderButton = function RenderButton(_ref) {
  var _onClick = _ref.onClick,
      onClickLinkCallback = _ref.onClickLinkCallback,
      isExternal = _ref.isExternal,
      path = _ref.path,
      label = _ref.label,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (isExternal && path) {
    return /*#__PURE__*/React.createElement(AnchorButton, Object.assign({
      path: path,
      onClick: function onClick() {
        return onClickLinkCallback();
      }
    }, props), label || children);
  }

  if (!isExternal && path) {
    return /*#__PURE__*/React.createElement(LinkButton, Object.assign({
      to: path,
      onClick: function onClick() {
        return onClickLinkCallback();
      }
    }, props), label || children);
  }

  return /*#__PURE__*/React.createElement(Button, Object.assign({
    onClick: function onClick() {
      _onClick();

      onClickLinkCallback();
    }
  }, props), label || children);
};

RenderButton.defaultProps = {
  onClick: null,
  isExternal: false,
  path: undefined,
  label: undefined,
  onClickLinkCallback: function onClickLinkCallback() {},
  children: null
};
export default RenderButton;